import type { JSX } from 'react';
import type { AlternateAudioFile, ExtendedAudioDescriptionMp3File } from '~/graphql';
import { isNotNil } from '~/utilities/type-guards';
import { useAlternateAudioFilesQuery } from '~/singlePageApp/screens/MediaCustomize/Customize/AudioDescriptions/__gql/AlternateAudioFiles.gql.gen';
import { useExtendedAudioDescriptionMp3FilesQuery } from '~/singlePageApp/screens/MediaCustomize/Customize/AudioDescriptions/__gql/ExtendedAudioDescriptionMp3Files.gql.gen';
import { AudioDescriptionDownload } from './AudioDescriptionDownload';
import { ExtendedAudioDescriptionDownload } from './ExtendedAudioDescriptionDownload';
import { TabWrapper } from './SharedStyledComponents';

type Props = {
  hashedId: string;
};

export const AudioTab = ({ hashedId }: Props): JSX.Element => {
  const { data: alternateAudioFilesData } = useAlternateAudioFilesQuery({
    variables: { hashedId },
  });

  const { data: extendedAudioFilesData } = useExtendedAudioDescriptionMp3FilesQuery({
    variables: { hashedId },
  });

  const alternateAudioFiles = (alternateAudioFilesData?.media?.alternateAudioFiles ?? []).filter(
    ({ type }) => type !== 'Mp4AlternateAudioFile',
  );

  const extendedAudioFiles = (
    extendedAudioFilesData?.media?.extendedAudioDescriptionMp3Files ?? []
  ).filter(({ mediaExtendedAudioDescription }) => isNotNil(mediaExtendedAudioDescription));

  return (
    <TabWrapper>
      {alternateAudioFiles.length > 0 && (
        <AudioDescriptionDownload
          alternateAudioFiles={alternateAudioFiles as AlternateAudioFile[]}
        />
      )}

      {extendedAudioFiles.length > 0 && (
        <ExtendedAudioDescriptionDownload
          extendedAudioFiles={extendedAudioFiles as ExtendedAudioDescriptionMp3File[]}
        />
      )}
    </TabWrapper>
  );
};
